<template>
  <div class="w-full mt-10 mb-14 sm:w-auto max-w-xl">
    <p v-if="!hasEditableWorkOrders">
      Would you like to create a new work order according to this schedule?
    </p>
    <p v-else-if="numActive && numScheduled">

      You have <span class="font-semibold">{{ numActive }}</span> active and <span class="font-semibold">{{ numScheduled }}</span> scheduled previously generated work orders. Would you like to adjust their scheduled and due dates accordingly?
    </p>
    <p v-else-if="numActive && !numScheduled">
      You have <span class="font-semibold">{{ numActive }}</span> previously generated active work orders that are ready to be edited. Would you like to adjust their scheduled and due dates accordingly?
    </p>
    <p v-else-if="!numActive && numScheduled">
      You have <span class="font-semibold">{{ numScheduled }}</span> previously generated scheduled work orders that are ready to be edited. Would you like to adjust their scheduled and due dates accordingly?
    </p>
    <div class="w-full flex flex-row flex-wrap justify-between mt-8">
      <div class="w-full sm:w-1/2 my-1 sm:pr-1">
        <VButton
          label="Close"
          @click="closePrompt"
          outlined uppercase class="w-full h-12"
        />
      </div>
      <div class="w-full sm:w-1/2 my-1 sm:pl-1">
        <VButton
          :label="!hasEditableWorkOrders? 'Proceed' : 'New Work Order'"
          @click="createNewWorkOrder"
          :icon="hasEditableWorkOrders ? 'fa-plus' : null"
          icon-first
          :outlined="!!hasEditableWorkOrders" uppercase class="w-full h-12"
        />
      </div>
      <VButton
        v-if="!!hasEditableWorkOrders"
        label="Edit Work Orders"
        icon="fa-pen"
        icon-first
        @click="editWorkOrders"
        uppercase class="w-full h-12 my-1"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"

export default {
  name: "PostScheduleEditPrompt",
  components: {
    VButton
  },
  computed: {
    ...mapGetters(["getProceedArgs"]),
    schedule() {
      return this.getProceedArgs[0]
    },
    workOrders() {
      return this.getProceedArgs[1]
    },
    numActive() {
      return this.workOrders?.active?.results?.length
    },
    numScheduled() {
      return this.workOrders?.scheduled?.results?.length
    },
    hasEditableWorkOrders() {
      return this.numActive || this.numScheduled
    }
  },
  methods: {
    ...mapMutations([
      "closePrompt",
      "setActiveModal",
    ]),
    async createNewWorkOrder() {
      this.setActiveModal({
        component: "CreateWorkOrderModal",
        args: { schedule: this.schedule }
      })
      this.closePrompt()
    },
    async editWorkOrders() {
      this.setActiveModal({
        component: "SelectWorkOrderEditModal",
        args: {
          schedule: this.schedule,
          workOrders: this.workOrders
        }
      })
      this.closePrompt()
    }
  }
}
</script>